import React from "react";
import { Link } from 'gatsby';
import * as b from "./bootstrap.module.css";
import Icon from "../components/icon.tsx";
import Akredo from "../../static/assets/Logo-header-dark.svg";
import Translate from "./translate";
import PropsType from "prop-types";

const pages = [
  {to: "/kredyty/", text: 'Kredyty'},
  {to: "/banki/", text: 'Banki w Polsce'},
  {to: "/konta/", text: 'Konta'},
  {to: "/platnosci/", text: 'Płatności'},
  {to: "/pozyczki-pozabankowe/", text: 'Pożyczki pozabankowe'},
  {to: "/oszczednosci/", text: 'Oszczędności'},
  {to: "/bezpieczenstwo/", text: 'Bezpieczeństwo'},
  {to: "/posrednicy-kredytowi/", text: 'Pośrednicy kredytowi'},
  {to: "/zadluzenia/", text: 'Zadłużenia'},
  {to: "/pomoc-socjalna/", text: 'Pomoc socjalna w Polsce'},
]

const pages2 = [
  {to: "/polityka-prywatnosci/", text: 'Polityka prywatności', rel: "nofollow"},
  {to: "/regulamin/", text: 'Regulamin', rel: "nofollow"},
]

const socials = [
  {
    href: "https://twitter.com/akredo_pl?utm_source=akredo&utm_medium=text-link&utm_id=link",
    icon: <Icon color="#ffffff" size={20} icon="Twitter" className="footer-icon" />,
    text: "Twitter",
  },
  {
    href: "https://pl.linkedin.com/company/akredo-sp-z-o-o-?utm_source=akredo&utm_medium=text-link&utm_id=link",
    icon: <Icon color="#ffffff" size={20} icon="LinkedIn" className="footer-icon" />,
    text: "LinkedIn",
  },
  {
    href: "https://www.youtube.com/@AkredoPL",
    icon: <Icon color="#ffffff" size={20} icon="Youtube-fill" className="footer-icon" />,
    text: "YouTube",
  },
];

const Footer = ({ homePage }) => {
  return (
    <footer className={["footer", b.pbLg3, !homePage && b.mt5].join(' ')}>
      <div className={b.container}>
        <div className={[b.row, b.justifyContentCenter, b.justifyContentSmBetween, b.pt3, b.ptLg5].join(" ")}>
          <div className={b.colSmAuto}>
            <Link to="/" aria-label='Akredo.pl'>
              <Akredo />
            </Link>
          </div>

          <div className={[b.colMdAuto, b.dFlex, b.flexWrap, b.pt2, b.ptMd0].join(' ')}>
            {socials.map(({ href, icon, text }, i) => (
              <a key={i} href={href} target="_blank" rel="noopener noreferrer nofollow" className={["footer-list-link", b.mr3, b.mt2, b.mrMd0, b.mlMd3].join(' ')}>
                {icon}
                {text}
              </a>
            ))}
          </div>
        </div>

        <div className={[b.dLgFlex, b.flexWrap, "footer-list","footer-list-grid","main-links", b.my4, b.pbXl3, 'footer-border-bottom', b.prLg5, b.mrLg5].join(" ")}>
          {pages.map(({ to, text }, i) => (
            <div key={i} className={["font-size-18", b.mb3, b.mbLg2, b.mrLg4].join(' ')}>
              <Link to={to} activeClassName="active" className="footer-list-link">
                {text}
              </Link>
            </div>
          ))}
        </div>

        {homePage && (
          <div className={["footer-text", b.pb4, b.mb2].join(" ")}>
            <div className="footer-text-copy">
              <p>
                Porównywarka akredo.pl należy do Loando Group Sp. z o.o. z siedzibą w Olsztynie 10-166, przy ulicy Kotańskiego 8/1 , NIP 7393937829, REGON: 385610711 , KRS: 0000820312, kapitał zakładowy 50.000 zł opłacony w całości. Wszystkie z opisywanych instytucji finansowych, zarówno banki jak i firmy pożyczkowe,  mają prawo przekazać dane wnioskującego do Biur Informacji Gospodarczej, co może mieć realny wpływ 
                na <Link to="/kredyty/zdolnosc-kredytowa/">zdolność kredytową</Link> wnioskującego. Dzieje się to na mocy zapisów zawartych w artykułach 14, 16 oraz 17 ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych 
                (<a href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20100810530" target="_blank" rel="noreferrer nofollow">
                Dz.U. Nr 81, poz. 530</a>). 
                Podstawą prawną poświadczającą wpis do BIG jest pisemna umowa pomiędzy Pożyczkodawcą a Biurem Informacji Gospodarczej, regulująca proces udostępniania informacji gospodarczej, a także przepis rozdziału trzeciego stanowiący o udostępnianiu informacji i wymianie danych gospodarczych. Przedłużenie terminu spłaty pożyczki nie jest dokonywane automatycznie, tylko na wyraźny wniosek pożyczkobiorcy. Koszt takiego przedłużenia zależy od kwoty pożyczki, czasu, na jaki została ona udzielona oraz okresu przedłużenia. W przypadku opóźnienia w spłacie pożyczki, Pożyczkodawca naliczy odsetki maksymalne za opóźnienie (aktualnie 10% w skali roku). Ponadto, każda prezentowana przez nas instytucja finansowa lub bank, może obciążyć Pożyczkobiorcę dodatkowymi, ustalonymi przez siebie kosztami (np. monitami określonymi w Tabeli Opłat dostępnej na stronie internetowej każdej z instytucji, a także kosztami postępowania windykacyjnego i sądowego. Szczegółowe informacje dotyczące dodatkowych kosztów pożyczki lub kredytu można także znaleźć na naszej stronie akredo.pl. Akredo.pl to porównywarka, której celem jest ułatwienie wnioskowania o kredyt lub pożyczkę, oraz pozwolenie na nieodpłatną symulację kosztów kredytu lub pożyczki. Przedstawione opisy pożyczek nie stanowią oferty w rozumieniu art. 66 Kodeksu Cywilnego. Ta strona używa ciasteczek. Korzystając ze strony wyrażasz zgodę na używanie ciasteczek, zgodnie z aktualnymi ustawieniami przeglądarki.
              </p>

              <p className={b.mb0}>
                Możecie się z nami skontaktować pod 
                numerem: <a href="tel:+48727154837" rel="nofollow">727154837</a> lub 
                adresem email: <a href="mail:bok@loando.pl" rel="nofollow">bok@loando.pl</a>.  
                W sprawach danych osobowych prosimy o kontakt pod adresem <a href="mail:rodo@akredo.pl" rel="nofollow">rodo@akredo.pl</a>.
              </p>
            </div>
          </div>
        )}

        <div className={[b.row, b.alignItemsCenter, b.justifyContentBetween, b.pb4].join(' ')}>
          <div className={[b.colLgAuto, b.dFlex, b.orderLgLast, b.mb4, b.pb2, b.mbLg0, b.pbLg0].join(' ')}>
            {pages2.map(({ to, text, rel }, i) => (
              <Link key={i} to={to} rel={rel} className={["footer-list-link", b.mr3, b.mrLg0, b.mlLg3].join(' ')}>
                {text}
              </Link>
            ))}
          </div>

          <p className={[b.colLgAuto, b.mb0].join(' ')}>
            <Translate tKey="2022 © Akredo.pl. All rights reserved"/>
          </p>
        </div>
      </div>
    </footer>
  );
};

Footer.propsTypes = {
  homePage: PropsType.bool,
}

export default Footer;